import React from 'react';

/**
 * Whether a click carried a modifier key, i.e. the user asked the browser for something other than a plain
 * activation: a new tab, a new window, a download, an extended selection.
 *
 * A link that handles a plain click in the app (routing in place, opening a modal) must leave a modified click
 * alone, because the anchor's real `href` is what makes Cmd/Ctrl-click open a working tab instead of a dead one.
 */
export const isModifiedClick = (event: React.MouseEvent): boolean =>
	event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;

/**
 * Whether a click on a link should be handled in the app: the main button with no modifier key. Every other click
 * is left to the browser, so the link's href can open a new tab or window.
 */
export const isPlainClick = (event: React.MouseEvent): boolean => event.button === 0 && !isModifiedClick(event);
